// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent;
}

ion-footer {
  margin-bottom: 10px;
}

swiper {
  height: 100%;
}

ion-toolbar {
  --background: transparent;
}

.my_toolbar {
  position: absolute;
  background: black;
}

.my-fab {
  margin-top: var(--ion-safe-area-top);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/image-modal/image-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,oCAAA;AACF","sourcesContent":["ion-content {\n  --background: transparent;\n}\n\nion-footer {\n  margin-bottom: 10px;\n}\n\nswiper {\n  height: 100%;\n}\n\nion-toolbar {\n  --background: transparent;\n}\n\n.my_toolbar {\n  position: absolute;\n  background: black;\n}\n\n.my-fab {\n  margin-top: var(--ion-safe-area-top);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
